/* cl-cart-drawer (maison-corval): gaveta lateral = replica do app UpCart do concorrente.
   Abre no icone/link do carrinho do header e ao adicionar produto: intercepta (captura) todo form /cart/add;
   o buybox com bundle (cl-moon.js) entrega a lista de itens em form.__clItems(). Renderiza de /cart.js;
   quantidade/remocao por /cart/change.js; descontos automaticos aparecem como selos (titulo do desconto)
   e na linha "Reductions"; contador "Panier reserve pour MM:SS!" (sessao). */
(function () {
  var D = document.getElementById('ClCart');
  if (!D) return;
  var OV = document.getElementById('ClCartOverlay');
  var $ = function (s) { return D.querySelector(s); };
  var FMT = D.getAttribute('data-money') || '{{amount}}';
  var cart = null;

  function money(c) {
    var n = (c / 100).toFixed(2), p = n.split('.');
    var dot = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'), com = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FMT.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dot + ',' + p[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, com)
      .replace(/\{\{\s*amount\s*\}\}/, com + '.' + p[1]);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* reserva do carrinho */
  var MIN = +D.getAttribute('data-reserve') || 0, timer = null;
  function deadline() {
    var t = 0; try { t = +sessionStorage.getItem('clCartReserve') || 0; } catch (e) {}
    if (!t || t < Date.now()) { t = Date.now() + MIN * 60000; try { sessionStorage.setItem('clCartReserve', t); } catch (e) {} }
    return t;
  }
  function tick() {
    var el = $('[data-clc-reserve]'); if (!el || !MIN) return;
    var left = Math.max(0, deadline() - Date.now()), s = Math.floor(left / 1000);
    var mm = ('0' + Math.floor(s / 60)).slice(-2), ss = ('0' + (s % 60)).slice(-2);
    el.textContent = D.getAttribute('data-reserve-text').replace('{time}', mm + ':' + ss);
  }

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function open() {
    D.classList.add('is-open'); OV.classList.add('is-open'); D.setAttribute('aria-hidden', 'false'); lock(true);
    tick(); clearInterval(timer); timer = setInterval(tick, 1000);
  }
  function close() {
    D.classList.remove('is-open'); OV.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true'); lock(false);
    clearInterval(timer);
  }
  window.clCart = { open: function () { return refresh().then(open); }, close: close, refresh: function () { return refresh(); } };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cl-cart-close]')) { e.preventDefault(); close(); return; }
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], #cart-icon-bubble, [data-cart-icon], .header__icon--cart, [aria-controls="mini-cart"], [aria-controls="cart-drawer"]');
    if (a && !D.contains(a)) { e.preventDefault(); e.stopPropagation(); window.clCart.open(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && D.classList.contains('is-open')) close(); });

  function post(url, body) {
    var json = !(body instanceof FormData);
    return fetch(url, { method: 'POST', body: json ? JSON.stringify(body) : body,
      headers: json ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* adicionar: todo form /cart/add da pagina (buybox copiado, cards, upsell) */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1 || f.hasAttribute('data-cl-native')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var body;
    var items = typeof f.__clItems === 'function' ? f.__clItems() : null;
    if (items && items.length) body = { items: items };
    else {
      body = new FormData(f);
      var fid = f.getAttribute('id'); if (fid) document.querySelectorAll('input[form="' + fid + '"][name="quantity"]').forEach(function (q) { body.set('quantity', q.value || '1'); });
      if (!body.get('quantity')) body.set('quantity', '1');
    }
    var btn = e.submitter || f.querySelector('[type=submit]'); if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    post('/cart/add.js', body)
      .then(function () { return new Promise(function (r) { setTimeout(r, 350); }); })
      .then(refresh).then(open)
      .catch(function (err) { alert((err && (err.description || err.message)) || "Ce produit n'a pas pu etre ajoute au panier."); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }, true);

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); return c; });
  }
  function bubbles(n) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], #cart-icon-bubble .cart-count, cart-count, .header__cart-count').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var s = b.querySelector('span[aria-hidden]'); if (s) s.textContent = n; b.style.display = n ? '' : 'none';
    });
  }
  var TAG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M11 2h7v7l-9 9-7-7 9-9z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="14.5" cy="5.5" r="1.3" fill="currentColor"/></svg>';
  var TRASH = '<svg viewBox="0 0 15 15" width="15" height="15" aria-hidden="true"><path d="M3 4h9l-.8 10H3.8L3 4zM1.5 4h12M5.5 4V2h4v2M6 6.5v5M9 6.5v5" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>';
  var MINUS = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 6h6" stroke="currentColor" stroke-width="1"/></svg>';
  var PLUS = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 6h6M6 3v6" stroke="currentColor" stroke-width="1"/></svg>';
  function badge(t) { return '<span class="cl-uc__badge">' + TAG + esc(t) + '</span>'; }
  function line(it, i) {
    var unitCmp = Math.max(it.original_price || 0, (it.variant && it.variant.compare_at_price) || 0, it.compare_at_price || 0);
    var was = unitCmp * it.quantity;
    var saved = was > it.final_line_price ? was - it.final_line_price : 0;
    var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title' && o.value !== 'Default Title'; })
      .map(function (o) { return '<span class="cl-uc__opt">' + esc(o.name) + ': ' + esc(o.value) + '</span>'; }).join('');
    var titles = []; (it.discounts || []).forEach(function (d) { if (d.title && titles.indexOf(d.title) < 0) titles.push(d.title); });
    return '<div class="cl-uc__line" data-line="' + (i + 1) + '">' +
      '<a class="cl-uc__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(it.image, 264)) + '" alt="" width="88" height="88" loading="lazy"></a>' +
      '<div class="cl-uc__info"><div class="cl-uc__head"><div><h3 class="cl-uc__ltitle"><a href="' + esc(it.url) + '" style="color:inherit;text-decoration:none">' + esc(it.product_title) + '</a></h3>' + opts + '</div>' +
      '<button type="button" class="cl-uc__trash" data-remove aria-label="Supprimer">' + TRASH + '</button></div>' +
      '<div class="cl-uc__row"><div class="cl-uc__qty"><button type="button" data-q="-1" aria-label="Diminuer la quantite">' + MINUS + '</button>' +
      '<input type="number" min="0" step="1" inputmode="numeric" value="' + it.quantity + '" aria-label="Quantite">' +
      '<button type="button" data-q="1" aria-label="Augmenter la quantite">' + PLUS + '</button></div>' +
      '<div class="cl-uc__prices">' + (saved ? '<span class="cl-uc__was">' + money(was) + '</span>' : '') +
      '<span class="cl-uc__now">' + money(it.final_line_price) + '</span>' +
      (saved ? '<span class="cl-uc__save">' + esc(D.getAttribute('data-save').replace('{amount}', money(saved))) + '</span>' : '') +
      (titles.length ? '<div class="cl-uc__lbadges">' + titles.map(badge).join('') + '</div>' : '') +
      '</div></div></div></div>';
  }
  function render() {
    var n = cart.item_count;
    bubbles(n);
    $('[data-clc-count]').textContent = n;
    $('[data-clc-empty]').hidden = n > 0;
    $('[data-clc-full]').hidden = n === 0;
    $('[data-clc-items]').innerHTML = cart.items.map(line).join('');
    var disc = 0, titles = [];
    cart.items.forEach(function (it) { (it.discounts || []).forEach(function (d) { disc += d.amount || 0; if (titles.indexOf(d.title) < 0) titles.push(d.title); }); });
    (cart.cart_level_discount_applications || []).forEach(function (d) { disc += d.total_allocated_amount || 0; if (titles.indexOf(d.title) < 0) titles.push(d.title); });
    $('[data-clc-savings]').hidden = !disc;
    $('[data-clc-badges]').innerHTML = titles.map(badge).join('');
    $('[data-clc-saved]').textContent = '- ' + money(disc);
    $('[data-clc-checkout-label]').textContent = D.getAttribute('data-checkout').replace('{total}', money(cart.total_price));
    tick();
  }
  function change(lineNo, qty) {
    var row = D.querySelector('.cl-uc__line[data-line="' + lineNo + '"]'); if (row) row.classList.add('is-busy');
    return post('/cart/change.js', { line: lineNo, quantity: qty })
      .then(function (c) { if (c && c.items) { cart = c; render(); } else return refresh(); })
      .catch(refresh);
  }
  D.addEventListener('change', function (e) {
    var q = e.target.closest('.cl-uc__qty input'); if (!q) return;
    change(+q.closest('.cl-uc__line').getAttribute('data-line'), Math.max(0, parseInt(q.value, 10) || 0));
  });
  D.addEventListener('click', function (e) {
    var r = e.target.closest('[data-remove]');
    if (r) { e.preventDefault(); change(+r.closest('.cl-uc__line').getAttribute('data-line'), 0); return; }
    var b = e.target.closest('[data-q]');
    if (b) {
      e.preventDefault();
      var row = b.closest('.cl-uc__line'), inp = row.querySelector('input');
      change(+row.getAttribute('data-line'), Math.max(0, (parseInt(inp.value, 10) || 0) + (+b.getAttribute('data-q'))));
    }
  });
  refresh();
})();
